import { Common, Widget, color } from '@stockbit/ui';
import If from 'global/ErrorHandlers/If';
import { useState, ChangeEvent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { effects as watchlistEffects } from 'lib/entities/watchlist';
import { Input } from './styled';

const { Text, Flex, IconWrapper, Iconmoon } = Common;
const { Button } = Widget;

interface CreateWatchlistProps {
  companyId?: number;
  onAddWatchlist?: () => {};
}

function CreateWatchlist({ companyId, onAddWatchlist }: CreateWatchlistProps) {
  const dispatch = useDispatch();

  const [watchlistName, setWatchlistName] = useState<string>('');
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    return () => {
      setVisible(false);
      setWatchlistName('');
    };
  }, []);

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    setWatchlistName(e.target.value);
  };

  const handleSubmitWatchlistName = async (e) => {
    e?.preventDefault();

    if (watchlistName.length > 0) {
      const add = await dispatch(
        watchlistEffects.addCompanyWatchlist({
          name: watchlistName,
          companyId,
        }),
      );

      // @ts-ignore
      const { data } = add.payload;

      if (data) {
        setWatchlistName('');
        if (!!onAddWatchlist) {
          onAddWatchlist();
        }
      }
    }
  };

  const handleModalCancel = () => {
    setVisible(false);
  };

  const handleToggleForm = () => {
    setVisible(!visible);
  };

  return (
    <Flex direction="column" width="100%" style={{ gap: '10px' }}>
      <Flex
        align="center"
        style={{ gap: 8, cursor: 'pointer' }}
        onClick={handleToggleForm}
        width="100%"
      >
        <IconWrapper>
          <Iconmoon
            className="icon-toolbar_plus"
            color={color.primary}
            hoverColor={color.primary}
          />
        </IconWrapper>
        <Text size="18px" color={color.primary}>
          Create New Watchlist
        </Text>
      </Flex>
      <If condition={visible}>
        <div style={{ width: '100%' }}>
          <form onSubmit={handleSubmitWatchlistName}>
            <Input
              id="wl-name-modal"
              placeholder="Name your watchlist"
              height="40px"
              width="100%"
              onChange={handleOnChange}
              value={watchlistName}
              suffix={watchlistName.length + '/25'}
              maxLength={25}
            />
            <input type="submit" style={{ display: 'none' }} />
          </form>
          <Flex justify="flex-end" mt="10px">
            <Button
              height="40px"
              px="24px"
              borderLess
              onClick={handleModalCancel}
            >
              <Text color={color.primary}>CANCEL</Text>
            </Button>
            <Button
              type="primary"
              height="40px"
              px="24px"
              onClick={handleSubmitWatchlistName}
              style={{ borderRadius: '3px' }}
            >
              <Text color={color.light} align="center">
                CREATE
              </Text>
            </Button>
          </Flex>
        </div>
      </If>
    </Flex>
  );
}

export default CreateWatchlist;
